import React, { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { useTheme } from 'next-themes'
import QRCodeSVG from 'qrcode.react'

export type QRCodeProps = {
  displayAddress: string
  selectedCurrencyCode: string
  protocol: string
  size?: number
  isLoading?: boolean
}

export const QRCode = ({
  displayAddress,
  selectedCurrencyCode,
  protocol,
  size = 120,
  isLoading = false,
}: QRCodeProps) => {
  const pathName = usePathname()

  let currencyIcon

  if (selectedCurrencyCode === protocol || !protocol) {
    currencyIcon = `${selectedCurrencyCode}`
  } else {
    currencyIcon = `${selectedCurrencyCode}-${protocol}`
  }

  const [isMounted, setMount] = useState(false)
  const { resolvedTheme } = useTheme()
  const isUsingShadyCasper = pathName?.includes('payin') || pathName?.includes('channel')

  const bgColor = isUsingShadyCasper && resolvedTheme === 'dark' ? '#21262E' : '#ffffff'
  const fgColor = isUsingShadyCasper && resolvedTheme === 'dark' ? '#FCFCFD' : '#161E28'

  useEffect(() => {
    setMount(true)
  }, [])

  return (
    <>
      {isLoading || !isMounted ? (
        <div
          className="bg-surface-static animate-pulse"
          style={{ height: `${size}px`, width: `${size}px` }}
        />
      ) : (
        <QRCodeSVG
          value={displayAddress}
          size={size}
          bgColor={bgColor}
          fgColor={fgColor}
          level={'M'}
          imageSettings={{
            src: `${process.env.ICONS_URL}/${currencyIcon}-border.svg`,
            x: undefined,
            y: undefined,
            height: 40,
            width: 40,
            excavate: false,
          }}
        />
      )}
    </>
  )
}
